import { createCollectionReducer } from 'reducers/account/collections';

const TYPE = 'userSegments';

export default createCollectionReducer(TYPE);

export const selectUserSegments = (state, userId) =>
  state.account.userSegments[userId];
